import { useQuery } from '@tanstack/react-query'

import { dashboardApi } from '@/features/dashboard/api'
import type { DashboardFilters } from '@/features/dashboard/types'

const REFRESH_MS = 30_000

export function useKpis(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'kpis', filters],
    queryFn: () => dashboardApi.kpis(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useRisksWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'risks', filters],
    queryFn: () => dashboardApi.risks(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useAlertsWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'alerts', filters],
    queryFn: () => dashboardApi.alerts(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useTrendsWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'trends', filters],
    queryFn: () => dashboardApi.trends(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useActivityWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'activity', filters],
    queryFn: () => dashboardApi.activity(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useRecommendationsWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'recommendations', filters],
    queryFn: () => dashboardApi.recommendations(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useImportsWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'imports', filters],
    queryFn: () => dashboardApi.imports(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function useTerritorialWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'territorial', filters],
    queryFn: () => dashboardApi.territorial(filters),
    refetchInterval: REFRESH_MS,
  })
}

export function usePredictionsWidget(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', 'predictions', filters],
    queryFn: () => dashboardApi.predictions(filters),
    refetchInterval: REFRESH_MS,
  })
}
